import React, { useState } from 'react';
import PropTypes from 'prop-types';
// Config
import { IMAGE_BASE_URL, PROFILE_SIZE } from '../../config';
// Helpers
import { initials } from '../../helpers';
// Components
import Button from '../Button';
// Styles
import { Wrapper, Header, List, Person } from './Cast.styles';

const PREVIEW = 12;

const Cast = ({ actors }) => {
  const [expanded, setExpanded] = useState(false);
  if (!actors || actors.length === 0) return null;

  const shown = expanded ? actors : actors.slice(0, PREVIEW);

  return (
    <Wrapper>
      <Header>
        <span>Cast</span>
        <h2>
          Starring <em>{actors.length}</em>
        </h2>
      </Header>
      <List>
        {shown.map((actor, i) => (
          <Person
            key={actor.credit_id}
            style={{ animationDelay: `${Math.min(i, PREVIEW) * 30}ms` }}
          >
            {actor.profile_path ? (
              <img
                src={`${IMAGE_BASE_URL}${PROFILE_SIZE}${actor.profile_path}`}
                alt=''
                loading='lazy'
              />
            ) : (
              <div className='fallback' aria-hidden='true'>
                {initials(actor.name)}
              </div>
            )}
            <div>
              <h3>{actor.name}</h3>
              {actor.character && <p>as {actor.character}</p>}
            </div>
          </Person>
        ))}
      </List>
      {actors.length > PREVIEW && (
        <div className='more'>
          <Button
            variant='ghost'
            text={expanded ? 'Show fewer' : `Show full cast (${actors.length})`}
            callback={() => setExpanded(e => !e)}
          />
        </div>
      )}
    </Wrapper>
  );
};

Cast.propTypes = {
  actors: PropTypes.array
};

export default Cast;
